<template>
  <q-drawer
    v-if="!isMobile"
    :model-value="true"
    :mini="miniDrawer || notificationsDialog"
    :width="230"
    :mini-width="80"
    behavior="desktop"
    role="navigation"
    no-swipe-backdrop
    bordered
  >
    <q-btn
      class="bg-white z-max"
      round
      :style="{
        right: '-15px',
      }"
      style="position: absolute; top: 16px; pointer-events: all"
      :icon="miniDrawer ? tabOutlineChevronsRight : tabOutlineChevronsLeft"
      size="10px"
      unelevated
      @click="$store.commit('setMiniDrawer', !miniDrawer)"
    />
    <q-scroll-area class="fit">
      <q-list
        padding
        class="q-gutter-y-sm q-px-sm flex column"
        :style="{ maxWidth: miniDrawer ? '80px' : '230px' }"
      >

        <q-item
          class="flex items-center justify-between q-pa-none q-ma-none q-gutter-y-sm"
          :class="{
            'column': miniDrawer,
            'q-pr-md row truncate-text no-wrap ': !miniDrawer,
          }"
        >
          <OrganizationsDropdown
            :avatar="miniDrawer"
            :class="{
              'full-width': miniDrawer,
            }"
          />
          <RecordWidgetBtn
            :withText="false"
          />
          <!-- :style="miniDrawer ? 'margin:8px auto 0' : 'position: absolute;right: 24px;top: 8px;'" -->
        </q-item>

        <DrawerItem :icon="tabOutlineHome" to="/meetings" matchPath="/meetings" name="Meetings" />
        <DrawerItem :icon="tabOutlineUsers" to="/team" name="Team Stats" />
        <DrawerItem
          :icon="tabOutlinePlayerPlay"
          to="/playlists"
          matchPath="/playlists"
          name="Playlists"
        />
        <DrawerItem
          :icon="tabOutlineMessageChatbot"
          to="/insights"
          matchPath="/insights"
          name="Insights"
        >
          <q-badge round floating color="blue-7" label="Beta" style="right: -16px; top: -8px" />
        </DrawerItem>
        <DrawerItem
          :icon="tabOutlineSettings"
          to="/settings"
          matchPath="/settings"
          name="Settings"
        />
        <DrawerItem
          :icon="tabOutlineCalendar"
          to="/calendar"
          matchPath="/calendar"
          name="Calendar"
        />
        <DrawerItem
          :icon="tabOutlineBell"
          @click="
            () => {
              notificationsDialog = true;
            }
          "
          :active="notificationsDialog"
          matchPath="/notifications"
          name="Notifications"
        >
          <q-badge
            v-if="notificationsCount"
            rounded
            style="right: -12px; top: -8px"
            color="red"
            floating
            :label="notificationsCount"
          />
        </DrawerItem>
        <DrawerItem
          v-if="userProfile?.type === 'super-user'"
          :icon="tabOutlineShieldStar"
          to="/admin"
          matchPath="/admin"
          name="Super User Panel"
        />
        <FeedbackFormBtn />
        <DarkModeButton :mini="miniDrawer" class="absolute-bottom "/>
      </q-list>
    </q-scroll-area>
    <NotificationsDialog
      v-model:showDialog="notificationsDialog"
      :onDialogHide="
        () => {
          notificationsDialog = false;
        }
      "
      v-if="!isMobile && userProfile?.uid"
    />
  </q-drawer>
</template>

<script setup>
import { Capacitor } from '@capacitor/core';

import { useStore } from 'vuex';
import DrawerItem from '@/components/blocks/DrawerItem.vue';
import RecordWidgetBtn from '@/components/blocks/RecordWidget/RecordWidgetBtn.vue';
import FeedbackFormBtn from '@/components/blocks/FeedbackForm/FeedbackFormBtn.vue';
import NotificationsDialog from '@/components/pages/Notifications/NotificationsDialog.vue';
import DarkModeButton from '@/components/blocks/DarkModeButton.vue';
import OrganizationsDropdown from './OrganizationsDropdown.vue';

import {
  tabOutlineChevronsLeft,
  tabOutlineChevronsRight,
  tabOutlineShieldStar,
  tabOutlineBell,
  tabOutlineSettings,
  tabOutlinePlayerPlay,
  tabOutlineUsers,
  tabOutlineHome,
  tabOutlineMessageChatbot,
  tabOutlineCalendar,
} from 'quasar-extras-svg-icons/tabler-icons-v3';

import { computed, ref } from 'vue';
import { useQuasar } from 'quasar';

const $q = useQuasar();
const $store = useStore();

const notificationsDialog = ref(false);

const isMobile = computed(() => Capacitor.isNativePlatform() || $q.screen.width < 600);
const miniDrawer = computed(() => $store.state.miniDrawer);

const userProfile = computed(() => $store.state.userProfile);

// const isAdmin = computed(() => $store.getters.getRole(userProfile.value?.uid) === 'admin');

const notificationsCount = computed(() => {
  return $store.state.notifications.filter((notification) => !notification.isRead).length;
});
</script>
